<template>
    <div class="px-6 mt-[42px] flex flex-row justify-between">
        <div>
            <h2
                class="mt-2 font-medium leading-6 text-iron-700 tracking-[-0.01em]"
            >
                <slot name="title" />
            </h2>

            <h3 class="text-sm leading-5 text-iron-500 mt-[3px] font-[Inter]">
                <slot name="description" />
            </h3>
        </div>
        <div>
            <slot name="actions" />
        </div>
    </div>
</template>
